/*
  NattyPLUS PDP Buy Box v2 — layout helper
  Groups Judge.me reviews + total-sold tag into one trust row and moves
  subtitle below the title when buy-box v2 is active (theme setting or Intelligems class).
*/
(function () {
  var ROOT_SELECTORS = ['html.np-pdp-buy-box-v2', 'body.np-pdp-buy-box-v2', '.product.np-pdp-buy-box-v2'];

  function isV2Active() {
    return ROOT_SELECTORS.some(function (sel) {
      return document.querySelector(sel);
    });
  }

  function findSoldTag(info) {
    var tags = info.querySelectorAll('.product-information-tag-block');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if (tag.classList.contains('np-pdp-subtitle-block')) continue;
      if (tag.querySelector('.product-information-tag__body p')) continue;
      if (tag.querySelector('.product-information-tag__heading-icon-wrap')) return tag;
      if (tag.textContent && /sold/i.test(tag.textContent)) return tag;
    }
    return null;
  }

  function findSubtitleBlock(info) {
    var tags = info.querySelectorAll('.product-information-tag-block');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if (tag.querySelector('.product-information-tag__body p')) {
        return tag;
      }
    }
    return null;
  }

  function layoutSubscriptionCards() {
    document.querySelectorAll('.np-sub-widget .np-card').forEach(function (card) {
      var head = card.querySelector('.np-card-head');
      if (!head) return;

      var badge = card.querySelector(':scope > .np-badge') || head.querySelector('.np-badge');
      var headMain = head.querySelector('.np-card-head-main');
      var prices = head.querySelector('.np-card-prices, .np-price-onetime-wrap');
      var delivery = card.querySelector(':scope > .np-v2-delivery');

      if (badge && headMain && badge.parentElement !== head) {
        headMain.insertAdjacentElement('afterend', badge);
      }

      if (delivery && prices && delivery.parentElement !== head) {
        prices.insertAdjacentElement('afterend', delivery);
      }
    });
  }

  function setV2DefaultCard() {
    document.querySelectorAll('.np-sub-widget').forEach(function (widget) {
      if (widget.dataset.npBuyBoxV2DefaultDone === '1') return;

      var urlPlan = new URLSearchParams(window.location.search).get('selling_plan');
      if (urlPlan) {
        widget.dataset.npBuyBoxV2DefaultDone = '1';
        return;
      }

      var firstCard = widget.querySelector('.np-card--gold');
      if (!firstCard) {
        widget.dataset.npBuyBoxV2DefaultDone = '1';
        return;
      }

      var widgetApi = window.__npWidget && window.__npWidget.el === widget ? window.__npWidget : null;
      if (!widgetApi && !widget.dataset.npBuyBoxV2Retry) {
        widget.dataset.npBuyBoxV2Retry = '1';
        requestAnimationFrame(setV2DefaultCard);
        return;
      }

      if (widgetApi && typeof widgetApi.activateCard === 'function') {
        widgetApi.activateCard(firstCard);
      } else {
        widget.querySelectorAll('.np-card').forEach(function (c) {
          c.classList.remove('np-active');
        });
        firstCard.classList.add('np-active');
        document.dispatchEvent(
          new CustomEvent('np:selection-change', {
            detail: {
              purchaseType: firstCard.dataset.purchase || 'subscription',
              variantId: firstCard.dataset.variantId || widget.dataset.initialVariant,
            },
          })
        );
      }

      widget.dataset.npBuyBoxV2DefaultDone = '1';
    });
  }

  function layoutProductInfo(info) {
    var reviews = info.querySelector('.custom-app-block[data-custom-app]');
    var sold = findSoldTag(info);
    var subtitle = findSubtitleBlock(info);
    var title = info.querySelector('.product-general-info-block:not(:has(.product-price-wrapper))');

    if (!info.querySelector('.np-pdp-trust-row') && (reviews || sold)) {
      var trustRow = document.createElement('div');
      trustRow.className = 'np-pdp-trust-row';

      if (reviews) trustRow.appendChild(reviews);

      if (reviews && sold) {
        var divider = document.createElement('span');
        divider.className = 'np-pdp-trust-divider';
        divider.setAttribute('aria-hidden', 'true');
        divider.textContent = '|';
        trustRow.appendChild(divider);
      }

      if (sold) {
        sold.classList.add('np-pdp-sold-tag');
        trustRow.appendChild(sold);
      }

      info.insertBefore(trustRow, info.firstChild);
    }

    if (subtitle) {
      subtitle.classList.add('np-pdp-subtitle-block');
      if (title && title.nextElementSibling !== subtitle) {
        title.insertAdjacentElement('afterend', subtitle);
      }
    }

    var benefits = info.querySelector('[data-np-atf-benefits]');
    if (benefits) {
      var anchor = subtitle || title;
      if (anchor && anchor.nextElementSibling !== benefits) {
        anchor.insertAdjacentElement('afterend', benefits);
      }
    }
  }

  function boot() {
    if (!isV2Active()) return;

    document.querySelectorAll('.product .product__info').forEach(layoutProductInfo);
    layoutSubscriptionCards();
    setV2DefaultCard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  new MutationObserver(function () {
    if (isV2Active()) boot();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*
  Add-To-Cart hover sweep (2026-10)
  ---------------------------------
  Arms the one-directional white sweep on the PDP's Add To Cart and on the
  sticky buy bar's button. Styles live in assets/np-pdp-buy-box-v2.css.

  Why this needs JS at all: the sweep is one-directional — the panel enters from
  the TOP on hover and leaves out the BOTTOM — which takes two keyframes, and
  the OUT keyframe starts from a state that COVERS the button. If that rule were
  live at page load it would play once unprompted and flash white across the
  button, which on the PDP is right above the fold. So the OUT rule is scoped to
  .np-swept, and a button only gets that class the first time it is actually
  hovered: before the first hover there is nothing to animate out.

  Delegated from the document so it covers buttons that are re-rendered later
  (the widget rebuilds its cards on plan/variant change) without re-binding.
  To disable, delete this block and the .np-swept rules in the stylesheet.
*/
(function () {
  var SEL = '.np-cta, .np-ab-atc, .np-sticky-btn';
  document.addEventListener(
    'pointerenter',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest(SEL);
      if (btn && !btn.classList.contains('np-swept')) btn.classList.add('np-swept');
    },
    true // capture: pointerenter does not bubble
  );
})();

/*
  Plan-card open animation on the PDP (2026-10)
  ---------------------------------------------
  In the quick-add popup, choosing 30-day / 90-day / one-time grows the chosen
  card's details open (np-subscription-widget: .np-card-body animates
  grid-template-rows 0fr → 1fr). On the PDP the buy-box v2 / Idea6 styles swap
  that body between display:none and display:block — with !important, at very
  high specificity (Idea6 injects its CSS at runtime) — so nothing can
  transition and the card snapped open. Client: make the PDP match the popup.

  Rather than out-specify Idea6, animate in JS: when a card inside the PDP buy
  box gains .np-active, measure its now-visible body and run the same motion
  with the Web Animations API — height 0 → natural, fade in, 0.38s, the
  popup's cubic-bezier(0.4, 0, 0.2, 1). The inline animation leaves no styles
  behind when it ends. Only cards under `.product` are touched (the popup is
  not inside .product and keeps its CSS animation); the initial active card on
  page load is not animated, only changes. Respects prefers-reduced-motion.
  To disable, delete this block.
*/
(function () {
  if (!('animate' in Element.prototype)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function openCard(card) {
    var body = card.querySelector('.np-card-body');
    if (!body || !body.offsetParent) return; // not shown (e.g. collapsed layout)
    var h = body.scrollHeight;
    if (!h) return;
    if (body.__npOpenAnim) body.__npOpenAnim.cancel();
    body.__npOpenAnim = body.animate(
      [
        { height: '0px', opacity: 0, overflow: 'hidden' },
        { height: h + 'px', opacity: 1, overflow: 'hidden' }
      ],
      { duration: 380, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      var el = m.target;
      if (m.type !== 'attributes' || !el.classList || !el.classList.contains('np-card')) continue;
      var wasActive = (m.oldValue || '').split(/\s+/).indexOf('np-active') > -1;
      if (wasActive || !el.classList.contains('np-active')) continue;
      if (!el.closest('.product') || el.closest('.np-tps-modal')) continue;
      openCard(el);
    }
  });

  function start() {
    mo.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Bundle PDP rating score (2026-10)
  ---------------------------------
  The Judge.me preview badge shows stars + "277 reviews" but no score. Its
  root carries data-average-rating (e.g. 4.89), so insert "4.89/5" (the exact
  average, up to two decimals) between the stars and the count.
  Bundle PDPs only (.product[data-np-palette="gold"]). Idempotent, and re-run
  briefly after load because Judge.me can re-render the badge. Styled by
  .np-rating-score in np-pdp-overrides.css.
*/
(function () {
  function addScores() {
    document
      .querySelectorAll('.product[data-np-palette="gold"] .jdgm-prev-badge[data-average-rating]')
      .forEach(function (badge) {
        if (badge.querySelector('.np-rating-score')) return;
        var avg = parseFloat(badge.getAttribute('data-average-rating'));
        var text = badge.querySelector('.jdgm-prev-badge__text');
        if (!avg || !text) return;
        var span = document.createElement('span');
        span.className = 'np-rating-score';
        // Exact Judge.me average (e.g. 4.89), not rounded — client wants the
        // real figure. parseFloat drops trailing zeros (4.90 → 4.9).
        span.textContent = parseFloat(avg.toFixed(2)) + '/5';
        text.parentNode.insertBefore(span, text);
      });
  }
  function run() {
    addScores();
    setTimeout(addScores, 1500);
    setTimeout(addScores, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
